import styles from "./placeholders.module.css";

type PlaceholderProps = {
  eyebrow: string;
  title: string;
  subtitle: string;
  panelTitle: string;
  panelBody: string;
};

const Placeholder = ({ eyebrow, title, subtitle, panelTitle, panelBody }: PlaceholderProps): JSX.Element => (
  <div className={styles.page}>
    <header className={styles.header}>
      <span className={styles.eyebrow}>{eyebrow}</span>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.subtitle}>{subtitle}</p>
    </header>
    <div className={styles.panel}>
      <h2 className={styles.panelTitle}>{panelTitle}</h2>
      <p className={styles.panelBody}>{panelBody}</p>
    </div>
  </div>
);

export const Connectors = (): JSX.Element => (
  <Placeholder
    eyebrow="Connectors"
    title="Connectors"
    subtitle="Plug your OpenClaw into the tools you already use — chat platforms, issue trackers, knowledge bases, and more."
    panelTitle="Connector catalog coming soon"
    panelBody="Telegram, Slack, Discord, and WhatsApp Business setup will land here as part of M2."
  />
);

export const Monitoring = (): JSX.Element => (
  <Placeholder
    eyebrow="Monitoring"
    title="Monitoring"
    subtitle="Uptime, request volume, and cost signals for every OpenClaw you run."
    panelTitle="Dashboards coming soon"
    panelBody="Live metrics will stream from CloudWatch once the monitoring stack is wired up."
  />
);
